import React, {useState} from 'react';
import {useSelector} from "react-redux";

import css from './PriceTableSingleComponent.module.css';


const PriceTableSingleComponent = ({pack, period}) => {
    const {periods} = useSelector((store) => store.periods);
    const {pricePerDay} = pack;

    const [first, setFirst] = useState(pricePerDay - ((pricePerDay / 100) * periods[0]?.discount));
    const [second, setSecond] = useState((pricePerDay - ((pricePerDay / 100) * periods[1].discount)) * 2);
    const [three, setThree] = useState((pricePerDay - ((pricePerDay / 100) * periods[2].discount)) * 4);
    const [four, setFour] = useState((pricePerDay - ((pricePerDay / 100) * periods[3].discount)) * 5);
    const [five, setFive] = useState((pricePerDay - ((pricePerDay / 100) * periods[4].discount)) * 7);
    const [six, setSix] = useState((pricePerDay - ((pricePerDay / 100) * periods[5].discount)) * 14);
    const [seven, setSeven] = useState((pricePerDay - ((pricePerDay / 100) * periods[6].discount)) * 20);
    const [eight, setEight] = useState((pricePerDay - ((pricePerDay / 100) * periods[7].discount)) * 30);


    return (
        <div className={css.wrap}>
            <div className={css.item}>
                <input
                    type="number"
                    value={first}
                />
            </div>

            <div className={css.item}>
                <input
                    type="number"
                    value={second}
                />
            </div>

            <div className={css.item}>
                <input
                    type="number"
                    value={three}
                />
            </div>

            <div className={css.item}>
                <input
                    type="number"
                    value={four}
                />
            </div>

            <div className={css.item}>
                <input
                    type="number"
                    value={five}
                />
            </div>

            <div className={css.item}>
                <input
                    type="number"
                    value={six}
                />
            </div>

            <div className={css.item}>
                <input
                    type="number"
                    value={seven}
                />
            </div>

            <div className={css.item}>
                <input
                    type="number"
                    value={eight}
                />
            </div>
        </div>
    );
};

export default React.memo(PriceTableSingleComponent);



